$(() => {
    // nav-mobile
    if ($(window).width() < 1280) {
        $(document).on('click', '.nav-item-wrapper > .nav-item', function (e) {
            $(this).toggleClass('open').next().slideToggle();
            $('.nav-item-wrapper>.nav-item').not(this).removeClass('open').next().slideUp();
        });

        $(document).on('click', '.nav-item-inner', function (e) {
            $(this).toggleClass('active').next().slideToggle(400, "linear");
            // $('.nav-item-inner').not(this).removeClass('active1');
            // $('.nav-item-inner').not(this).removeClass('active').next().slideUp();
        });
    }
});

$(() => {
    try {
        if ($(window).width() < 1265) {
            $(".nav-item-wrapper > .nav-item > a").removeAttr('href');
        }
    } catch (error) { }
});

$(() => {
    // Menu mobile close
    $('.nav-close, .nav-wrapper-bg').click(function () {
        $(".nav-wrapper").removeClass("show");
        $(".nav-wrapper-bg").removeClass("show-bg");
        $(".pp__bg").removeClass("show");
        $(".header-bottom").removeClass("menu");
        $(".header").removeClass("menu");
        $(".logo-wrapper").removeClass("menu");
        $(".menu-logo-bg").removeClass("menu");
        $("html").removeClass("noscroll");
    });

    // Menu mobile open
    $('.burger-wrapper').click(function () {
        $(".nav-wrapper").addClass("show");
        $(".nav-wrapper-bg").addClass("show-bg");
        $(".pp__bg").addClass("show");
        $(".header-bottom").addClass("menu");
        $(".header").addClass("menu");
        $(".logo-wrapper").addClass("menu");
        $(".menu-logo-bg").addClass("menu");
        $("html").addClass("noscroll");
    });
});
